import React from 'react';
import {useAuth} from "react-oidc-context";
import {useLocation} from "react-router-dom";

export default function Login() {
    const location = useLocation();
    const auth = useAuth();
    auth.signinRedirect({redirect_uri: window.location.origin + location.state.from.pathname});
    return( <></> );
}